import {  Box,  Card, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { Helpers } from '../../services/Helpers';
import { DataGrid } from '@mui/x-data-grid';
import NoRowsLayout from '../../components/Layout/NoRowsLayout';

const ViewDetails = (props) => {
    const {selectedBrandData} = props;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const columns = [
        { field: 'service', headerName: 'Master Service', flex: 1,
            valueGetter: (params) => params.row.sDetail ? params.row.sDetail.title : '',
            renderCell: (params) => (
                <Box sx={{p:1}}>
                <Typography sx={{fontSize:'0.65rem'}}>
                    {params.value}
                </Typography>
                </Box>
            ),
        },
        { field: 'subCategory', headerName: 'Sub Category', flex: 1,
            valueGetter: (params) => params.row.sDetail?.sCtR[0].catD ? params.row.sDetail.sCtR[0].catD.title : '',
            renderCell: (params) => (
                <Box sx={{p:1}}>
                <Typography sx={{fontSize:'0.65rem'}}>
                    {params.value}
                </Typography>
                </Box>
            )
        },
        { field: 'category', headerName: 'Category', flex: 1,
            valueGetter: (params) => params.row.sDetail?.sCtR[0].catD.parentCategory ? params.row.sDetail?.sCtR[0].catD.parentCategory.title : '',
            renderCell: (params) => (
                <Box sx={{p:1}}>
                <Typography sx={{fontSize:'0.65rem'}}>
                    {params.value}
                </Typography>
                </Box>
            )
        },
    ]
    const [serviceList, setServiceList] = useState([]);
    useEffect(() => {
        if(selectedBrandData && selectedBrandData.bSer.length>0){
            setServiceList(selectedBrandData.bSer);
        }
    }, [selectedBrandData]);
  return (
    <Box>
       <Box sx={{p:1}}>                
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Brand Name </Typography>
                            <TextField
                                name='bLevel'
                                value={selectedBrandData.title}
                                disabled
                                size='small'
                                fullWidth
                                inputProps={{
                                    style:{
                                        fontSize:'0.65rem'
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Brand Level </Typography>
                            <TextField
                                name='bLevel'
                                value={selectedBrandData.bLevel}
                                disabled
                                size='small'
                                fullWidth
                                inputProps={{
                                    style:{
                                        fontSize:'0.65rem'
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>
                                Service Image <Box component="span" sx={{ color: 'error.main' }}>*</Box>
                            </Typography>

                            <Box sx={{ textAlign: 'center'}}>
                                <Box sx={{height: '11rem',border:'1px dashed gray',borderRadius:'4px',mb:1}}>

                                
                                    {(selectedBrandData.image) && (
                                        <Box sx={{ mb: 2, justifyContent: 'center', boxShadow: '0 0 5px rgba(0,0,0,0.1)' ,height:'100%',display:'flex',alignItems:'center'}}>
                                            <img
                                                src={`${Helpers.ImagePathUrl()}/brands/md/${selectedBrandData.image}`}
                                                alt="Service"
                                                style={{ maxWidth: '100%' ,maxHeight:'100%' }}
                                            />
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid item xs={12} md={9}>
                    <Card sx={{}}>
                        <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
                            <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >{`Associated Services`}</Typography>
                        </Box>
                        <Box sx={{ overflow: "auto" }}>
                            <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
                            
                            <DataGrid
                                rows={serviceList}
                                columns={columns.map((col) => ({
                                ...col,
                                // flex: col.flex || 1, // Ensure columns resize dynamically
                                minWidth: isSmallScreen && (col.minWidth || 150), // Set a minimum width to avoid overlap
                                }))}
                                getRowId={(row) => row.masterServiceId}
                                //checkboxSelection={true}
                                rowCount={serviceList?.length}  // Use the length of the filtered list
                                pageSizeOptions={[5, 10, 20, 50, 100]}
            
                                disableColumnMenu
                                disableRowSelectionOnClick
                                slots={{
                                    noRowsOverlay: ()=>(
                                        <NoRowsLayout message='No Services Associated With This Brand' />
                                    ),     // when rows = []
                                    noResultsOverlay: () => (
                                        <NoRowsLayout message='No No Services matched your search ' />  // when filtered rows = []
                                    ),
                                }}
                                autoHeight
                                getRowHeight={() => 'auto'}
                                sx={{
                                '& .MuiDataGrid-cell': {
                                    border: 1,
                                    borderRight: 0,
                                    borderTop: 0,
                                    borderColor: 'lightgrey',
                                    display: 'flex',
                                    alignItems: 'center',
                                    // justifyContent: 'center',
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                    borderBottom: '2px solid rgba(224, 224, 224, 1)',
                                    borderTop: '2px solid rgba(224, 224, 224, 1)',
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    p: 0,
                                    height: 'fit-content',
                                    minHeight: '0 !important',
                                    height: '2rem'
                                },
                                '& .MuiDataGrid-columnHeader': {
                                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                    '&:last-child': {
                                    borderRight: 'none',
                                    },
                                },
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 600,
                                    color: '#3e3e3e'
                                },
                                '& .MuiDataGrid-row': {
                                    '&:last-child .MuiDataGrid-cell': {
                                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                                    },
                                    '& .MuiDataGrid-cell:last-child': {
                                    borderRight: 'none',
                                    },
                                },
                                '& .MuiDataGrid-columnSeparator': {
                                    display: 'none',
                                },
                                }}
                            />
                            </Box>
                        </Box>
                    </Card>
                </Grid>
                
            </Grid>                              
        </Box>
        
    </Box>
  );
}

export default ViewDetails;